<span>Verification requested</span>
<span class="requests-history-btn" data-cy="see-verification-requests" (click)="onOpenHistory()">See all requests</span>
